import { FlatNode } from '../pages/mindmap/types';

export const getTopLeftCoords = (node: FlatNode) => {
  if (node.x == null || node.y == null) {
    throw new Error('Missing x or y property from node.');
  }
  return {
    x: node.x,
    y: node.y,
  };
};
